import { useState } from 'react';
import { procurementApi } from '@/api/procurement.api';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import { showApiError } from '@/utils/apiError';
import { notify } from '@/core/toast/notify';

const REPORTS = [
  { type: 'PO', label: 'Purchase orders' },
  { type: 'RFQ', label: 'RFQs' },
  { type: 'GRN', label: 'Goods receipts' },
  { type: 'SPEND', label: 'Spend analysis' },
  { type: 'VENDOR_BILL', label: 'Vendor bills' },
  { type: 'PR', label: 'Purchase requests' },
];

export function ProcurementReportsPage() {
  const [busy, setBusy] = useState<string | null>(null);

  const download = async (reportType: string, format: 'CSV' | 'PDF' | 'EXCEL') => {
    setBusy(`${reportType}-${format}`);
    try {
      const response = await procurementApi.exportReport(reportType, format);
      const contentType = response.headers['content-type'];
      const blob = new Blob([response.data], {
        type: typeof contentType === 'string' ? contentType : 'application/octet-stream',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const ext = format === 'EXCEL' ? 'xlsx' : format.toLowerCase();
      a.download = `${reportType.toLowerCase()}.${ext}`;
      a.click();
      URL.revokeObjectURL(url);
      notify.success(`${reportType} exported`);
    } catch (err) {
      showApiError(err, 'Export failed');
    } finally {
      setBusy(null);
    }
  };

  return (
    <div>
      <PageHeader
        title="Procurement reports"
        description="Export operational and spend reports"
        breadcrumbs={[{ label: 'Procurement', to: '/procurement' }, { label: 'Reports' }]}
      />
      <div className="grid gap-4 sm:grid-cols-2">
        {REPORTS.map((r) => (
          <div key={r.type} className="card p-4">
            <p className="font-semibold">{r.label}</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {(['CSV', 'PDF', 'EXCEL'] as const).map((fmt) => (
                <Button
                  key={fmt}
                  variant="secondary"
                  loading={busy === `${r.type}-${fmt}`}
                  onClick={() => void download(r.type, fmt)}
                >
                  {fmt}
                </Button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
